<div class="container mt-3">
    <h2>{{'item.edit.curate.title' |translate:{item: (itemName$ |async)} }}</h2>
    <ds-curation-form
      *ngIf="dsoRD$ | async as dsoRD"
      [dsoHandle]="dsoRD?.payload.handle"
    ></ds-curation-form>
</div>
